<template>
    <div :class="{ 'login-container': true, 'dark-mode': displayConfirmation }">

        <b-modal v-model="displayConfirmation" title="Confirmation" @ok="confirmCU">
            <div>
                <p>Voulez-vous vous connecter en tant que :</p>
                <p>{{ selectedThirdparty.name }}</p>
                <p>{{ selectedThirdparty.address }} {{ selectedThirdparty.zip }} {{ selectedThirdparty.town }}</p>
            </div>
        </b-modal>


        <div :class="{ 'middle-pane': true, 'dark-mode': displayConfirmation }">
            <div class="form-container">
                <div class="logo">
                    <img src="../assets/icon.png" alt="Logo" />
                </div>
                <h1 style="width: 100%; text-align: center; align-items: center; justify-content: center;">
                    <b>Vous souhaitez vous connecter à :</b>
                </h1>
                <form v-on:submit.prevent="getThirdpartyByCU(post.code_client)">
                    <div class="input-field">
                        <label for="email">Code client</label>
                        <input type="text" id="code_client" placeholder="CU..." v-model="post.code_client" required>
                    </div>
                    <div class="button-container">
                        <button type="submit" class="login-button"><b>CONNEXION</b></button>
                    </div>
                </form>
            </div>

        </div>
    </div>
</template>

<script>
import script_aloha from '../script/script_pointage'

export default {
    data() {
        return {
            post: {},
            displayConfirmation: false,
            selectedThirdparty: {},
        }
    },

    async created() {
        const codeClientCookie = await this.getCookie('code_client');
        const thirdpartyNameCookie = await this.getCookie('thirdpartyName')
        const thirdpartyIdCookie = await this.getCookie('thirdpartyId')
        if (codeClientCookie && codeClientCookie!== undefined && thirdpartyNameCookie && thirdpartyNameCookie!== undefined && thirdpartyIdCookie && thirdpartyIdCookie!== undefined ) {
            this.$router.push('/login')
        }
    },

    methods: {
        getThirdpartyByCodeClient: script_aloha.getThirdpartyByCU,

        onAccountCreated() {
            this.$router.push("ConfirmationInscription")
        },

        async getThirdpartyByCU(code_client) {
            let thirdparty = await this.getThirdpartyByCodeClient(code_client);
            this.selectedThirdparty = thirdparty[0]
            this.displayConfirmation = true
        },

        async confirmCU() {
            document.cookie = `code_client=${this.selectedThirdparty.code_client}`
            document.cookie = `thirdpartyName=${this.selectedThirdparty.name}`
            document.cookie = `thirdpartyId=${this.selectedThirdparty.id}`
            document.cookie = `dolibarr_url=${this.selectedThirdparty.array_options.options_serveur_dolibarr}`
            this.$router.push('login')
        },

        async getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
 
                }
            }
            return "";
        },
    },
}
</script>

<style scoped>
.dark-mode {
    background-color: rgba(0, 0, 0, 0.5);
    /* Réglez l'opacité selon vos préférences */
}

.login-container {
    display: flex;
    background: #ddd;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.middle-pane {
    border-radius: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    height: 65%;
    width: 40%;
    box-shadow: 0px 0px 35px 45px rgba(0, 0, 0, 0.1);
}

.form-container {
    width: 60%;
}

.logo img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 35%;
    /* Adjust as needed */
}

.input-field {
    margin-top: 50px;
    margin-bottom: 50px;
}

.input-field label {
    display: block;
}

.input-field input {
    width: 100%;
    outline: 0;
    border-color: #ccc;
    border-width: 0 0 2px;
    margin-top: 0.5rem;
}

.input-field input:focus {
    border-color: #ffa500;
    outline: 0px #000;
}

.button-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-button {
    background-color: #ffa500;
    /* Customize to match your brand */
    color: white;
    border: none;
    padding: 1rem 2rem;
    margin-top: 1rem;
    cursor: pointer;
    width: 50%;
    border-radius: 20px;
    /* Rounded corners for the button */
}

@media (max-width: 768px) {
    .login-container {
        flex-direction: column;
    }

    .left-pane,
    .right-pane {
        flex: none;
        width: 100%;
    }

    .form-container {
        margin-top: 2rem;
    }
}
</style>